import moment from "moment";

const CLICK_GENERATOR_URL = "https://a.vtrk1.co/d/:campaignId.js?oref=&ourl=:siteUrl&opt=&vtm=:timestamp";

const POSTBACK_CONFIG = {
  TH: {
    campaignId: "cc962385-69d0-401d-bf56-e6e78ec0879d",
    siteUrl: "https://ilovevip.com/",
  },
  PH: {
    campaignId: "462f3166-4d7b-4a60-a0df-8531fb263c28",
    siteUrl: "https://ilovevipph.com/",
  },
} as const;

export const retrieveNewVoluumCid = async (deployCountry: "TH" | "PH") => {
  const config = POSTBACK_CONFIG[deployCountry];
  if (!config) throw new Error("invalid deploy country:" + deployCountry);

  const cidUrl = CLICK_GENERATOR_URL.replace(":campaignId", config.campaignId)
    .replace(":siteUrl", config.siteUrl)
    .replace(":timestamp", moment().unix().toString());

  const response = await fetch(cidUrl);
  const result = await response.text();
  const cid = result.match(/"cid":"([a-z0-9]+)"/i)?.[1];
  if (!cid) throw new Error("unable to retrieve voluum cid");

  return cid;
};
